"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsoluteDateFilterForm = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DateRangePicker_1 = require("../DateRangePicker/DateRangePicker");
var conversions_1 = require("./conversions");
var dayPickerProps = {
    mode: "range",
    weekStartsOn: 0,
};
/**
 * @internal
 */
var AbsoluteDateFilterForm = /** @class */ (function (_super) {
    tslib_1.__extends(AbsoluteDateFilterForm, _super);
    function AbsoluteDateFilterForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRangeChange = function (range) {
            var _a = _this.props, selectedFilterOption = _a.selectedFilterOption, isTimeEnabled = _a.isTimeEnabled;
            _this.props.onSelectedFilterOptionChange(conversions_1.dateRangeToDateFilterValue(range, selectedFilterOption.localIdentifier, isTimeEnabled));
        };
        return _this;
    }
    AbsoluteDateFilterForm.prototype.render = function () {
        var _a = this.props, dateFormat = _a.dateFormat, isMobile = _a.isMobile, selectedFilterOption = _a.selectedFilterOption, errors = _a.errors, isTimeEnabled = _a.isTimeEnabled;
        return (react_1.default.createElement(DateRangePicker_1.DateRangePicker, { dateFormat: dateFormat, onRangeChange: this.handleRangeChange, range: conversions_1.dateFilterValueToDateRange(selectedFilterOption, isTimeEnabled), errors: errors, isMobile: isMobile, dayPickerProps: dayPickerProps, isTimeEnabled: isTimeEnabled }));
    };
    return AbsoluteDateFilterForm;
}(react_1.default.Component));
exports.AbsoluteDateFilterForm = AbsoluteDateFilterForm;
//# sourceMappingURL=AbsoluteDateFilterForm.js.map